import React from "react";

function ExpertsMultipleMarketsIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M17.351 26.545l3.533 1.465a20.4 20.4 0 00-.95 3.097l-.134.61 5.064 5.066.609-.13a20.414 20.414 0 003.097-.95l1.465 3.532a.228.228 0 00.374.073l2.214-2.214a3.654 3.654 0 001.066-2.768l-.079-1.422c4.099-3.027 8.247-8.335 9.377-17.599a1.523 1.523 0 00-1.709-1.718c-9.26 1.14-14.572 5.29-17.599 9.377l-1.419-.073a3.655 3.655 0 00-2.768 1.05l-2.214 2.214a.229.229 0 00.073.39zm14.204-5.396a2.741 2.741 0 113.87 3.883 2.741 2.741 0 01-3.87-3.883zM16.69 37.189a3.597 3.597 0 00-1.827-.147.33.33 0 01-.304-.091.332.332 0 01-.067-.375c.648-1.394 2.369-4.199 5.484-1.933a.154.154 0 01.038.179.155.155 0 01-.038.052 3.384 3.384 0 00-1.288 2.771.247.247 0 00.238.238 3.38 3.38 0 002.77-1.26.156.156 0 01.188-.043c.02.01.039.024.053.042.433.515 1.623 2.196.305 3.819a3.426 3.426 0 01-2.296 1.218c-1.28.137-3.642.554-4.608 1.657a.332.332 0 01-.572-.122c-.341-1.163-.871-3.764 1.924-6.006z"
            ></path>
        </svg>
    );
}

export default ExpertsMultipleMarketsIcon;
